import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    innerOption: {
      padding: 12,
      color: theme.colors.grey550,
      display: 'flex',
      alignItems: 'center',
      '& img': {
        width: 20,
        marginRight: 6,
      },
    },
  }),
)

const FacilityOption = (props) => {
  const classes = useStyles()

  return (
    <div {...props.innerProps}>
      <div className={classes.innerOption}>
        <img
          src={`assets/icons/facilities/${props.data.value}.svg`}
          alt={`${props.data.label} icon`}
        />
        <span>{props.data.label}</span>
      </div>
    </div>
  )
}

export default FacilityOption
